.container {
  display: flex;
  margin: var(--space-big) 0;
  place-content: space-around space-around;
  width: 100%;
}

.pagination {
  display: flex;
}

.block {
  margin: 0 var(--space-small);
  padding: 0 !important;
  transition: none !important;
  width: 26px;
}

.hideOnDesktop {
  display: none !important;
}

@media screen and (width <= 500px) {
  .hideOnMobile {
    display: none !important;
  }

  .hideOnDesktop {
    display: inline-block !important;
  }
}
